import { connect } from '@client/decorators/common';
import { getSessionUserAdminStatus, getSessionUserState } from '@client/selectors/helpers/login';
import { logoutPendingSelector, impersonationPendingSelector } from '@client/selectors';
import { getCurrentLocationPath } from '@client/selectors/helpers/location';
import { EventWatcher } from '../../components/_helpers/EventWatcher';

const mapStateToProps = (state) => ({
  logoutPending: logoutPendingSelector(state),
  pathname: getCurrentLocationPath(state),
  impersonationPending: impersonationPendingSelector(state),
  userState: getSessionUserState(state),
  isAdmin: getSessionUserAdminStatus(state),
});

export const EventWatcherContainer = connect(mapStateToProps)(EventWatcher);

export default EventWatcherContainer;
